import { useEffect, useState } from 'react';
import { getSnapshot, getValidToken, subscribe, ThumbnailToken } from './token-store';

/**
 * Check 1 (proactive): ensures a fresh token exists BEFORE thumbnails render.
 * Returns null while the very first fetch is in flight — render a placeholder then.
 */
export function useThumbnailToken(): ThumbnailToken | null {
  // React 17: no useSyncExternalStore, so subscribe to the store manually.
  const [token, setToken] = useState<ThumbnailToken | null>(getSnapshot);

  useEffect(() => subscribe(() => setToken(getSnapshot())), []);

  useEffect(() => {
    // Kicks off a (deduped) refresh when missing or stale; store emit re-renders us.
    getValidToken().catch(() => {
      /* surfaced via image placeholders; next mount retries */
    });
  }, [token]);

  return token;
}
